var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{transparent: _vm.options.transparent}},[_c('BSpinner',{staticClass:"spinner"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }